import { Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React from 'react';
import { useSelector } from 'react-redux';
import FallbackTypography from 'src/components/shared/FallbackTypography';
import { summerySectionAction } from 'src/store/reservations/actions/ReservationOverviewActions';

const SummarySection = () => {	
    const { reservationOverview } = useSelector((state) => state.reservationsSummaryReducer);
	const {summaryFields} = summerySectionAction(reservationOverview);

    return (
        <>
            <Typography variant="body1" fontWeight="bold" mb={2}>Summary</Typography>
            <Grid container spacing={3} mb={3}>
                {summaryFields.map((field, index) => (
                    (field.alwaysVisible || field.visible) && (
                        <Grid key={index} size={{ xs: 12, sm: 2 }}>
                            <Typography variant="body2" fontWeight="bold" mb={1}>
                                {field.label}
                            </Typography>
                            <FallbackTypography variant="body2" value={field.value} />
                        </Grid>
                    )
                ))}
            </Grid>
            <Divider sx={{ mb: 3 }} />
        </>
    );
};

export default SummarySection;